export default [{"tag":"path","att":{"d":"M19 12 7 19V5l12 7z"}}]